module.exports = __webpack_public_path__ + "media/images/left-1474f0fbb1845f4abb6a8d5de31e7060.png";